import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/admin/Panel";
import { api, formatErr } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordPanel = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const error = f.next && f.next.length < 10 ? "Use at least 10 characters." : f.confirm && f.confirm !== f.next ? "Passwords don't match." : "";
  const ready = f.current && f.next.length >= 10 && f.next === f.confirm;

  const submit = async (e) => {
    e.preventDefault();
    if (!ready) return;
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF(EMPTY);
      toast.success("Password changed. Other devices have been signed out.");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel title="Change password" testId="settings-change-password-panel">
      <form onSubmit={submit} className="grid gap-3 max-w-md">
        <Input type="password" autoComplete="current-password" placeholder="Current password" value={f.current} onChange={set("current")} className="h-11 rounded-xl" data-testid="admin-password-current-input" />
        <Input type="password" autoComplete="new-password" placeholder="New password (10+ characters)" value={f.next} onChange={set("next")} className="h-11 rounded-xl" data-testid="admin-password-new-input" />
        <Input type="password" autoComplete="new-password" placeholder="Confirm new password" value={f.confirm} onChange={set("confirm")} className="h-11 rounded-xl" data-testid="admin-password-confirm-input" />
        {error && <p className="text-xs font-semibold text-destructive" data-testid="admin-password-error">{error}</p>}
        <button type="submit" disabled={!ready || busy} className="inline-flex h-10 w-fit items-center gap-2 px-5 rounded-full bg-primary text-primary-foreground font-bold text-sm disabled:opacity-50" data-testid="admin-password-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}Update password
        </button>
        <p className="text-xs text-muted-foreground">You stay signed in here. Other devices are signed out and a security alert is emailed to your notification inbox.</p>
      </form>
    </Panel>
  );
};
